export const faqsGeneral = {
  name: 'general',
  list: [
    {
      heading: 'I manage more than one building, how do I view both?',
      text:
        'On the navigation bar you should see one of your buildings in a drop down menu. Click on that menu to toggle between your sites. You can view one building at a time. If you don’t see one of your sites listed, please contact us at support@paritygo.com',
    },
    {
      heading: 'How do I change my password?',
      text:
        'Click on the Account section of the left navigation bar. You should see a Change Password section. Enter your Old Password, a New Password and a Confirmed Password then click Change Password to confirm. You should see a success message if it updated correctly.',
    },
    {
      heading: 'How do I change my personal details?',
      text:
        'Click on the Account section of the left navigation bar. You should see a Profile section. Enter your details then click Save to confirm. You should see a success message if it updated correctly.',
    },
    {
      heading: 'What is a Kilowatt hour (kWh)?',
      text:
        'The kilowatt hour is a unit of energy. You are billed by your utility company based on the amount of kWh your building consumes.',
    },
    {
      heading: 'What is a Cubic Metre (m3)?',
      text:
        'This is the unit of measurement for natural gas. You will be billed by your natural gas provider based on the amount of m3 your building consumes.',
    },
  ],
};

export const faqsEnergyReports = {
  name: 'energyReports',
  list: [
    {
      heading: 'How do I view a savings report?',
      text:
        'View a savings report by clicking on either Electrical Usage or Gas Usage. The Overview page displays either all gas processes or all electrical processes. Selecting an individual process will show you its energy data.',
    },
    {
      heading: 'How do I change the date range?',
      text:
        'Adjust the graph’s time period with the drop down in the top right corner. You can choose a preselected date range or choose a custom date. If selecting a custom date, choose a start and end date. You will not be able to choose dates prior to your project’s start date.',
    },
    {
      heading: 'What does the Baseline value represent?',
      text: 'Refers to the amount of energy your building uses regularly without the Parity system installed. ',
    },
    {
      heading: 'What does the Target value represent?',
      text: 'Refers to the amount of energy your building is projected to be using with the Parity system installed.',
    },
    {
      heading: 'What does the Actual value represent?',
      text: 'Represents the measured usage of your building.',
    },
    {
      heading: 'What are weather adjusted savings?',
      text:
        "Your utility bills and the weather trends are compared against previous years. The variations are factored out so savings or losses are not attributed to extreme weather conditions. This means your usage is normalized against historical weather data. For example, if it's a milder winter and you use less heating, Parity won't get credit for the extra gas savings.",
    },
  ],
};

export const faqsDiagnostics = {
  name: 'diagnostics',
  list: [
    {
      heading: 'What is a register number?',
      text:
        'A register number corresponds to a device that is measuring or controlling a specific property of your mechanical equipment.',
    },
    {
      heading: 'What is the smallest time interval I can view?',
      text:
        'The time interval between data points on the graph will vary depending on which date range you have selected. The smallest time interval is 15 minute data which is available for time ranges smaller than 48 hours.',
    },
    {
      heading: 'How often does the graph data update?',
      text: 'New data is available every 15 minutes. In order to receive the latest data, refresh the page.',
    },
    {
      heading: 'How do I add and remove registers from the graph?',
      text:
        'Find the Legend below the graph. Click on the Add/Remove Lines button on the right. A modal should popup with a list of all available registers. You can view a maximum of 7 registers at one time on a graph.',
    },
    {
      heading: 'Why can’t I add more than 7 registers to the graph?',
      text:
        'The limit of displaying 7 lines is to maintain the graph’s readability. If you have a specific use case where you need to see more than 7 registers at once, please contact us at support@paritygo.com.',
    },
    {
      heading: 'How can I share a graph view with another member of my team?',
      text:
        'If your team member has the same permissions as you, you can simply send them the URL found in your browser’s address bar.',
    },
    {
      heading: 'Can I save default register preferences on the graph?',
      text:
        'Not yet. This feature is on our product roadmap though. In the meantime you can select your desired preferences and bookmark the page for quick access.',
    },
  ],
};
